<template>
  <b-modal @ok='submit' @hidden="resetAll" @cancel='cancel' :title="widgetActionTitle" class="modal-light" size="lg" v-model="modal" scrollable>
    <b-tabs>
      <b-tab title="Widget" active>
        <div class="mt-2" v-if='!selectWidgetMode && !newWidgetMode'>
          <b-row class='text-center'>
            <b-col sm="6">
              <b-button class="modal-btn" @click="changeMode('new')">Add new widget</b-button>
            </b-col>
            <b-col sm="6">
              <b-button class="modal-btn" @click="changeMode('existing')">Select existing widget</b-button>
            </b-col>
          </b-row>
        </div>
        <div v-if='selectWidgetMode'>
          <v-select class='select-no-caret' :on-change='addExistingWidget' v-model='widget' :options="existingWidgets" />
        </div>
        <div class="mt-2" v-if='newWidgetMode'>
          <b-row>
            <b-col sm="3">Main title:</b-col>
            <b-col sm="9"><b-form-input type='text' v-model="title"></b-form-input> </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">Disable Legend:</b-col>
            <b-col sm="9">
              <b-form-checkbox v-model="disableLegend" value="true" unchecked-value="false" />
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">Shared widget:</b-col>
            <b-col sm="9">
              <b-form-checkbox v-model="sharedWidget" value="true" unchecked-value="false" />
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="3">Click Through widget:</b-col>
            <b-col sm="9">
              <b-form-checkbox v-model="clickThrough" value="true" unchecked-value="false" />
            </b-col>
          </b-row>
          <b-row v-if="clickThrough">
            <b-col sm="3">Click Through Section:</b-col>
            <b-col sm="9">
              <v-select class='select-no-caret' :value="clickThroughSectionObject" :options="sections" @input="setClickThroughSection" />
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">Lock date range:</b-col>
            <b-col sm="9">
              <b-form-checkbox v-model="lockDatesCheckbox" value="true" unchecked-value="false" />
              <v-select v-if="lockDatesCheckbox === 'true' || lockDatesCheckbox === true" class='select-no-caret' :on-change='updateLockDates' v-model='lockDateRange' :options='lockDateRangeOptions' />
              <date-range-picker v-if="lockDateRange && lockDateRange.value === 'custom'" @update='updateCustomLockDates' :startDate='lockStartDate' :endDate='lockEndDate' />
              <div class='form-check' v-if="lockDatesCheckbox">
                <b-form-checkbox v-model="compareDatesCheckbox" value="true" unchecked-value="false">Compare</b-form-checkbox>
                <date-range-picker v-if="compareDatesCheckbox === 'true'" @update='updateCompareDates' :startDate='compareStartDate' :endDate='compareEndDate' />
              </div>
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm="3">Widget type:</b-col>
            <b-col sm="9">
              <v-select class='select-no-caret' v-model='widgetType' :options="widgetTypesOptions" />
            </b-col>
          </b-row>
          <br>
          <b-row v-if="widgetType === 'Table'">
            <b-col sm="3">Hide Pagination And Search:</b-col>
            <b-col sm="9">
              <b-form-checkbox v-model="hideTableControls" value="true" unchecked-value="false" />
            </b-col>
          </b-row>
          <b-row v-if="widgetType === 'Number'">
            <b-col sm="3">Hide Metric Labels:</b-col>
            <b-col sm="9">
              <b-form-checkbox v-model="hideMetricLabel" value="true" unchecked-value="false" />
            </b-col>
          </b-row>
          <br>
          <template v-if="widgetType === 'Bar'">
            <b-row>
              <b-col sm="3">Stacked:</b-col>
              <b-col sm="9">
                <b-form-checkbox v-model="stackedBarChart" value="true" unchecked-value="false" />
              </b-col>
            </b-row>
            <br>
          </template>
          <template v-if="widgetType === 'Funnel'">
            <b-row>
              <b-col sm="3">Reverse:</b-col>
              <b-col sm="9">
                <b-form-checkbox v-model="reverseFunnel" value="true" unchecked-value="false" />
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">Show As Pyramid:</b-col>
              <b-col sm="9">
                <b-form-checkbox v-model="asPyramid" value="true" unchecked-value="false" />
              </b-col>
            </b-row>
            <br>
          </template>
          <b-row>
            <b-col sm="3">Data source: </b-col>
            <b-col sm="9">
              <v-select :on-change='loadMetrics' class='select-no-caret' v-model='dataSource' :options="widgetDataSources" />
            </b-col>
          </b-row>
          <br>
          <template v-if='dataSource'>
            <b-row >
              <b-col sm="3">Metrics:</b-col>
              <b-col sm="9">
                <v-select :multiple="widgetType === 'Number'" :on-change='loadTableColumns' :key='forceRerenderMetrics' class='select-no-caret' v-model='metrics' :options="widgetMetrics" />
              </b-col>
            </b-row>
            <br>
            <b-row v-if="widgetType === 'Number' || widgetType === 'Doughnut'" >
              <b-col sm="3">Metric labels:</b-col>
              <b-col sm="9">
                <v-select multiple class='select-no-caret' v-model='widget_titles' :taggable='true' :closeOnSelect="false" :options="widgetTitles" />
              </b-col>
              <br>
            </b-row>
            <br>
          </template>
          <template v-if='(widgetType === "Table" && dataSource && metrics.length > 0) || groupableByDate'>
            <b-row>
              <b-col sm="3">Group by: </b-col>
              <b-col sm="9">
                <v-select class='select-no-caret' multiple v-model='groupBy' :options="groupByOptions" />
              </b-col>
            </b-row>
            <br>
          </template>
          <b-row>
            <b-col sm='3'>Dashboard:</b-col>
            <b-col sm='9'>
              <v-select class='select-no-caret' :on-change='loadSections' v-model='dashboard' :options="dashboardsList" />
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm='3'>Section:</b-col>
            <b-col sm='9'>
              <v-select class='select-no-caret' v-model='section' :options="sections" />
            </b-col>
          </b-row>
          <br>
          <b-row>
            <b-col sm='3' v-if="dataSource && filters.length > 0">Filters:</b-col>
            <b-col sm='9' v-if="dataSource && metrics.length > 0">
              <b-button v-if="dataSource && filters.length > 0" v-b-toggle.table-collapse class="btn mb-1"><span class="when-opened">Hide</span> <span class="when-closed">Show</span> Filters</b-button>
              <b-collapse visible id="table-collapse">
                <table class='table table-light'>
                  <tr v-for="item in filters" v-bind:key='item.id'>
                    <td> {{ item.filter_combine }} </td>
                    <td> {{ item.filter_condition }} </td>
                    <td> {{ item.filter_column_name }} </td>
                    <td v-if="item.filter_inclusion"> {{ item.filter_inclusion }} </td>
                    <td v-if="item.filter_comparison"> {{ item.filter_comparison }} </td>
                    <td v-if="!isNaN(Number(item.filter_value))" id="filteredValue"> {{ item.filter_value }} </td>
                    <td v-if="Array.isArray(item.filter_value) && item.filter_value.length > 0"> {{ item.filter_value.join(', ') }} </td>
                    <td><b-button type="button" @click='removeFilter(item)' class="btn">Remove</b-button></td>
                  </tr>
                </table>
              </b-collapse>
            </b-col>
          </b-row>
          <b-row v-if="dataSource">
            <b-col sm='1'>Filters:</b-col>
            <b-col sm="10">
              <b-row class="filter-dropdowns">
                <b-col sm="2" class="col-dropdown">
                  <v-select class='select-no-caret' v-model='filterCombine' :options="['(', ')']" />
                </b-col>
                <b-col sm="2" class="col-dropdown" v-if="filters.length > 0">
                  <v-select class='select-no-caret' v-model='filterCondition' :options="['and', 'or']" />
                </b-col>
                <b-col sm="3" class="col-dropdown">
                  <v-select class='select-no-caret' :on-change='loadFilterValues' v-model='filterColumnName' :options="filtersColumnsNames" />
                </b-col>
                <b-col v-if="!comparisonFilterType" sm="2" class="col-dropdown">
                  <v-select  class='select-no-caret' v-model='filterInclusion' :options="['include', 'exclude']" />
                </b-col>

                <b-col v-if="comparisonFilterType" sm="2" class="col-dropdown">
                  <v-select  class='select-no-caret' v-model='filterComparison' :options="['<', '=', '>', '<=', '>=']" />
                </b-col>

                <b-col v-if="!comparisonFilterType" sm="3" class="col-dropdown">
                  <v-select multiple :taggable="true" class='select-no-caret dropdown-multi' v-model='filterValue' :options="filterValues" />
                </b-col>
                <b-col v-if="comparisonFilterType" sm="3" class="col-dropdown">
                  <b-form-input type='text' v-model='filterValue'></b-form-input>
                </b-col>
                <b-col sm="2">
                  <b-button type="button" @click='addFilter' class="btn w-100 h-100 height-45">Add</b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <b-row v-if="widgetType === 'Table' || widgetType === 'Doughnut'">
            <b-col sm="3">Columns:</b-col>
            <b-col sm="9">
              <v-select class='select-no-caret' multiple v-model='columns' :options="tableColumns" />
            </b-col>
          </b-row>
          <br>
          <b-row v-if="widgetType === 'Table' && tableColumns.length > 0" >
            <b-col sm="3">Column labels:</b-col>
            <b-col sm="9">
              <v-select multiple class='select-no-caret' v-model='widget_titles' :taggable='true' :closeOnSelect="false" :options="widgetTitles" />
            </b-col>
            <br>
          </b-row>
          <br>
          <b-row v-if="widgetType === 'Table'">
            <b-col sm="3">Per Page:</b-col>
            <b-col sm="9">
              <b-form-input type='text' v-model="defaultPerPage"></b-form-input>
            </b-col>
          </b-row>
          <br>
          <b-row v-if="dataSource && widgetMetrics.length > 0 && widgetType === 'Table'">
            <b-col sm="3">Default Sorting:</b-col>
            <b-col sm="9">
              <b-row>
                <b-col sm="6">
                  <v-select class='select-no-caret' v-model='defaultSortColumn' :options="tableColumnsForSorting" />
                </b-col>
                <b-col sm="6">
                  <v-select class='select-no-caret' v-model='defaultSortOrder' :options="['ASC', 'DESC']" />
                </b-col>
              </b-row>
            </b-col>
          </b-row>
          <br>
          <b-row v-if="dataSource && widgetMetrics.length > 0 && (widgetType === 'Doughnut' || widgetType === 'Table')">
            <b-col sm="3"># records:</b-col>
            <b-col sm="9">
              <v-select class='select-no-caret' v-model='recordsAmount' :options="[5, 10, 15, 30]" />
            </b-col>
          </b-row>
          <br>
          <b-row v-if="dataSource && widgetMetrics.length > 0 && (widgetType === 'Linechart' || widgetType === 'Bar')">
            <b-col sm="3">Use Multiple Y Axes</b-col>
            <b-col sm="9">
              <b-check class='select-no-caret' v-model='multiYAxis' />
            </b-col>
          </b-row>
          <b-row v-if="dataSource && widgetMetrics.length > 0 && (widgetType === 'Table')">
            <b-col sm="3">Include Totals Row</b-col>
            <b-col sm="9">
              <b-check class='select-no-caret' v-model='includeTotalsRow' />
            </b-col>
          </b-row>
          <b-row v-if="widgetType === 'Doughnut'">
            <b-col sm="3">Use percentages in doughnut chart labels</b-col>
            <b-col sm="9">
              <b-check class='select-no-caret' v-model='useDoughnutPercentages' value="true" unchecked-value="false" />
            </b-col>
          </b-row>
          <b-row v-if="currentUser.isAdmin || (currentUser.id === ownerId)">
            <b-col sm="3">Lock widget</b-col>
            <b-col sm="9">
              <b-check class='select-no-caret' v-model='locked' />
            </b-col>
          </b-row>
          <b-row v-if="currentUser.isAdmin || (currentUser.id === ownerId)">
            <b-col sm="3">Disable Data Comparison</b-col>
            <b-col sm="9">
              <b-check class='select-no-caret' v-model='disableDataComparison' />
            </b-col>
          </b-row>
          <b-row v-if="metrics.length > 0 && (metrics[0]['label'] === 'Leads by inventory type' || metrics[0]['label'] === 'Leads by Date')">
            <b-col sm="3">Show unique leads</b-col>
            <b-col sm="9">
              <b-check class='select-no-caret' v-model='showUniqueLeads' />
            </b-col>
          </b-row>
        </div>
      </b-tab>
      <b-tab v-if="widgetActionTitle === 'Edit Widget'" title="Audits">
        <Audits :audits="widget.widget"/>
      </b-tab>
      <b-tab v-if="widgetActionTitle === 'Edit Widget'" title="Versions">
        <div id="versions-modal" role="tablist">
          <div v-for="(state, i) in stateHistory" :key="i">
            <b-card no-body class="mb-1" v-if="i < stateHistory.length - 1">
              <b-card-header header-tag="header" class="p-1" role="tab">
                <b-button block href="#" v-b-toggle="`state-${i}`" variant="info">{{ state.updated_at }} by {{ state.user.firstName }}</b-button>
              </b-card-header>
              <b-collapse :id="`state-${i}`" visible accordion="my-accordion" role="tabpanel">
                <b-card-body class="row">
                  <div class="col-sm">
                    <h5>CHANGED TO</h5>
                    <div class="table-container">
                      <table>
                        <tr v-for="(value, key, index) of state.widget" :key="index">
                          <td class="pull-right">{{key.replace(/_/g, " ").replace(/ id/g, "")}}:&nbsp;</td>
                          <td>&nbsp;{{showName(key, value)}}</td>
                        </tr>
                      </table>
                    </div>
                  </div>
                  <div class="col-sm">
                    <h5>CHANGED FROM</h5>
                    <div class="table-container">
                      <table>
                        <tr v-for="(value2, key2, index2) of stateHistory[i + 1].widget" :key="index2">
                          <td class="pull-right">{{key2.replace(/_/g, " ").replace(/ id/g, "")}}:&nbsp;</td>
                          <td>&nbsp;{{showName(key2, value2)}}</td>
                        </tr>
                      </table>
                    </div>
                    <button class="btn" @click="revertWidget(stateHistory[i + 1].widget)">REVERT</button>
                  </div>
                </b-card-body>
              </b-collapse>
            </b-card>
          </div>
        </div>
      </b-tab>
    </b-tabs>
  </b-modal>
</template>

<script>
import Audits from '../pages/Audits'
import vSelect from 'vue-select'
import DateRangePicker from 'vue2-daterange-picker'
import Moment from 'moment'
import { mapGetters, mapActions } from 'vuex'
import { dashboardMixins } from '@/shared/DashboardMixins'

export default {
  name: 'WidgetModal',
  components: {
    Audits,
    vSelect,
    DateRangePicker,
    Moment,
    dashboardMixins
  },

  data () {
    return {
      forceRerenderMetrics: 0,
      clickThrough: false,
      clickThroughSection: null,
      widget_titles: [],
      section: null,
      sections: [],
      dashboard: null,
      dashboardsList: [],
      disableDataComparison: false,
      showUniqueLeads: false,
      groupBy: [],
      groupByOptions: [],
      reverseFunnel: false,
      asPyramid: false,
      recordsAmount: null,
      defaultSortColumn: null,
      defaultSortOrder: null,
      compareDatesCheckbox: false,
      sharedWidget: false,
      newWidgetMode: false,
      selectWidgetMode: false,
      modal: false,
      widgetActionTitle: '',
      title: null,
      widget: null,
      widgetType: null,
      widgetTypesOptions: [],
      dataSource: null,
      widgetDataSources: [],
      metrics: [],
      widgetMetrics: [],
      columns: [],
      defaultPerPage: null,
      tableColumns: [],
      tableColumnsForSorting: [],
      filtersColumnsNames: [],
      filterColumnName: null,
      filterValue: null,
      filterValues: [],
      filterCondition: null,
      filterCombine: null,
      filters: [],
      lockDatesCheckbox: false,
      lockStartDate: null,
      lockEndDate: null,
      compareStartDate: null,
      compareEndDate: null,
      existingWidgets: [],
      lockDateRange: null,
      filterTypes: [],
      filterType: null,
      multiYAxis: false,
      locked: false,
      ownerId: null,
      stackedBarChart: false,
      includeTotalsRow: null,
      allMetrics: [],
      hideTableControls: false,
      useDoughnutPercentages: false,
      lockDateRangeOptions: [
        {
          label: 'Today',
          value: { startDate: Moment().startOf('day'), endDate: Moment().endOf('day') },
        },
        {
          label: 'Yesterday',
          value: { startDate: Moment().subtract(1, 'Days'), endDate: Moment().subtract(1, 'Days') }
        },
        {
          label: 'This week',
          value: { startDate: Moment().startOf('week'), endDate: Moment().endOf('week') }
        },
        {
          label: 'Last week',
          value: { startDate: Moment().subtract(1, 'week').startOf('week'), endDate: Moment().subtract(1, 'week').endOf('week') }
        },
        {
          label: 'Last 7 days',
          value: { startDate: Moment().subtract(7, 'Days'), endDate: Moment().endOf('day') }
        },
        {
          label: 'Last 14 days',
          value: { startDate: Moment().subtract(14, 'Days'), endDate: Moment().endOf('day') }
        },
        {
          label: 'Last 30 days',
          value: { startDate: Moment().subtract(30, 'Days'), endDate: Moment().endOf('day') }
        },
        {
          label: 'Last 90 days',
          value: { startDate: Moment().subtract(90, 'Days'), endDate: Moment().endOf('day') }
        },
        {
          label: 'This month',
          value: { startDate: Moment().startOf('month'), endDate: Moment().endOf('month') }
        },
        {
          label: 'Last month',
          value: { startDate: Moment().subtract(1, 'month').startOf('month'), endDate: Moment().subtract(1, 'month').endOf('month') }
        },
        {
          label: 'Last 3 months',
          value: { startDate: Moment().subtract(3, 'month').startOf('month'), endDate: Moment().endOf('month') }
        },
        {
          label: 'Last 6 months',
          value: { startDate: Moment().subtract(6, 'month').startOf('month'), endDate: Moment().endOf('month') }
        },
        {
          label: 'Last 12 months',
          value: { startDate: Moment().subtract(12, 'month').startOf('month'), endDate: Moment().endOf('month') }
        },
        {
          label: 'This quarter',
          value: { startDate: Moment().subtract(3, 'month').startOf('month'), endDate: Moment().endOf('month') }
        },
        {
          label: 'Last quarter',
          value: { startDate: Moment().subtract(6, 'month').startOf('month'), endDate: Moment().subtract(3, 'month').endOf('month') }
        },
        {
          label: 'This year',
          value: { startDate: Moment().startOf('year'), endDate: Moment().endOf('year') }
        },
        {
          label: 'Last year',
          value: { startDate: Moment().subtract(1, 'year').startOf('year'), endDate: Moment().subtract(1, 'year').endOf('year') }
        },
        {
          label: 'Custom(Fixed range)',
          value: 'custom'
        }
      ]
    }
  },

  created () {
    this.$eventBus.$on('addWidget', this.showModal)
    this.$eventBus.$on('editWidget', widget => this.edit(widget))
    this.loadWidgetTypes()
    this.loadDataSources()
    this.getWidgetTitles()
    this.loadAllMetrics()
    this.lockStartDate = this.$store.getters.startDate
    this.lockEndDate = this.$store.getters.endDate
    this.compareStartDate = this.$store.getters.startDate
    this.compareEndDate = this.$store.getters.endDate
  },

  beforeDestroy(){
    this.$eventBus.$off('addWidget')
    this.$eventBus.$off('editWidget')
  },

  methods: {
    ...mapActions(['getWidgetTitles', 'getDashboards']),
    setClickThroughSection (value) {
      this.clickThroughSection = value.value
    },

    formatDashboards () {
      this.dashboards.forEach(function(dashboard){
        this.dashboardsList.push({
          id: dashboard.id,
          label: dashboard.attributes.name
        })
        if (this.$route.params.id === dashboard.id){
          this.dashboard = {
            id: dashboard.id,
            label: dashboard.attributes.name
          }
        }
      }.bind(this))
      this.dashboardsList = this.dashboardsList.sort((a,b) => a.label.localeCompare(b.label))
    },

    addExistingWidget (widget) {
      this.widget = widget
      this.loadWidgetInfo()
    },

    addDefaultPerPage (params) {
      if (this.defaultPerPage) {
        params.options.default_per_page = this.defaultPerPage
      }
      return params
    },

    changeMode (type) {
      if (type === 'new'){
        this.newWidgetMode = true
      } else {
        this.selectWidgetMode = true
        this.widgetActionTitle = 'Add shared widget'
        this.loadExistingWidgets()
      }
    },

    showModal () {
      this.reset()
      this.setNewEditTitle('new')
      this.modal = true
    },

    edit (widget) {
      this.reset()
      this.widget = widget
      this.widget.dashboard_id = this.$route.params.id
      this.title = widget.title
      this.setNewEditTitle('edit')
      this.newWidgetMode = true
      this.modal = true
      this.loadWidgetInfo()
      if (this.dashboards.length === 0){
        this.getDashboards()
      }
      this.loadSections()
    },

    loadWidgetInfo () {
      var params = { widget_info: true }
      this.$http.get('/dashboards/'+this.$route.params.id+'/widgets/'+this.widget.id, {params: params})
        .then((data) => this.setWidgetInfo(data))
        .catch((e) => this.notifyError(e))
    },

    setWidgetInfo (response) {
      var data = response.data.data
      if (data.section){
        this.section = {label: data.section.name, value: parseInt(data.section.id, 10)}
      }
      this.title = data.widget.title
      this.funnel_order = data.widget.reverseFunnel ? 'desc' : 'asc'
      this.as_pyramid = data.widget.as_pyramid
      this.widget_titles = data.widget_titles.map(widget_title => { return {label: widget_title, value: widget_title} })
      this.sharedWidget = data.widget.shared ? true : false
      this.widgetType = data.widget.widget_type
      this.locked = data.widget.locked
      this.disableLegend = data.widget.disable_legend
      this.disableDataComparison = data.widget.disable_data_comparison
      this.showUniqueLeads = data.widget.options.show_unique_leads
      this.ownerId = data.widget.owner_id
      this.defaultPerPage = data.widget.options.default_per_page
      this.stackedBarChart = data.widget.stacked_barchart
      this.clickThrough = data.widget.click_through
      this.asPyramid = data.widget.as_pyramid
      this.clickThroughSection = data.widget.click_through_section
      this.hideTableControls = data.widget.hide_table_controls
      this.hideMetricLabel = data.widget.hide_metric_label
      this.useDoughnutPercentages = data.widget.use_doughnut_percentages
      this.dataSource = {
        value: data.data_source.id,
        label: data.data_source.source
      }
      this.metrics = data.metrics.map(function(metric){
        return {
          value: metric.id,
          label: metric.name,
          groupableByDate: metric.groupable_by_date
        }
      })
      this.forceRerenderMetrics += 1
      if (data.table_columns) {
        this.columns = data.table_columns.map(c => ({ value: c.id, label: c.name }))
      }
      if (data.options.group_by){
        this.groupBy = data.options.group_by
      }
      if (data.widget.filters.length > 0) {
        this.filters = data.widget.filters
      }
      if (data.widget.start_date && data.widget.end_date) {
        this.lockDatesCheckbox = true
        this.lockStartDate = Moment(data.widget.start_date)
        this.lockEndDate = Moment(data.widget.end_date)
        this.showLockRangeSelect()
      }
      if (data.widget.compare_start_date && data.widget.compare_end_date) {
        this.compareDatesCheckbox = 'true'
        this.compareStartDate = Moment(data.widget.compare_start_date)
        this.compareEndDate = Moment(data.widget.compare_end_date)
      }
      if (data.widget.options.default_sort_column){
        this.defaultSortColumn = data.widget.options.default_sort_column
      }
      if (data.widget.options.default_sort_order){
        this.defaultSortOrder = data.widget.options.default_sort_order
      }
      if (data.widget.options.records_amount) {
        this.recordsAmount = data.widget.options.records_amount
      }
      if (data.widget.options.multi_y_axis) {
        this.multiYAxis = data.widget.options.multi_y_axis
      }
      if (data.widget.options.include_totals_row) {
        this.includeTotalsRow = data.widget.options.include_totals_row
      }
    },

    revertWidget (params) {
      params.state = JSON.stringify({
        updated_at: Date.now(),
        user: this.currentUser,
        widget: params
      })
      this.widget.update(params, () => this.$parent.loadWidgets())
      this.selectWidgetMode = false
      this.newWidgetMode = false
      this.modal = false
    },

    showLockRangeSelect () {
      var rangeOption = this.lockDateRangeOptions.find(function(option){
        if (typeof option.value === 'object'){
          let startDate = option.value.startDate.format('YYYY-MM-DD')
          let endDate = option.value.endDate.format('YYYY-MM-DD')
          if (startDate === this.lockStartDate.format('YYYY-MM-DD') && endDate === this.lockEndDate.format('YYYY-MM-DD')){
            return option
          }
        }
      }.bind(this))
      if (rangeOption){
        this.lockDateRange = rangeOption
      } else { // custom range
        this.lockDateRange = this.lockDateRangeOptions[this.lockDateRangeOptions.length - 1]
      }
    },

    setNewEditTitle (state) {
      if (state === 'edit') {
        this.widgetActionTitle = 'Edit Widget'
      } else {
        this.widgetActionTitle = 'New Widget'
      }
    },

    submit (e) {
      e.preventDefault()
      if (!this.valid()){
        return false
      }
      if (this.widgetActionTitle === 'New Widget' || this.widget.makeClone) {
        this.create()
      } else if (this.widgetActionTitle === 'Add shared widget') {
        this.addSharedWidget()
      } else {
        this.update()
      }
      this.selectWidgetMode = false
      this.newWidgetMode = false
      this.modal = false
    },

    valid () {
      return this.title && this.widgetType && this.dataSource && this.metrics.length > 0
    },

    addSharedWidget () {
      var params = { add_shared: true }
      if (this.$parent.sections.length > 0){
        params.section_id = this.$parent.sections[this.$parent.currentTab].id
      }
      this.$http.patch('/dashboards/'+ this.$route.params.id +'/widgets/' + this.widget.id, params)
        .then(function(){
          this.$parent.loadWidgets()
        }.bind(this))
        .catch((e) => this.notifyError(e))
    },

    update () {
      var params = {
        title: this.title,
        widget_titles: this.widget_titles.map(widget_title => widget_title.label),
        widget_type: this.widgetType,
        data_source_id: this.dataSource.value,
        metric_ids: this.metrics.map(m => m.value),
        table_columns: this.columns.map(c => c.value),
        filters: this.filters,
        shared: this.sharedWidget,
        locked: this.locked,
        stacked_barchart: this.stackedBarChart,
        disable_legend: this.disableLegend,
        disable_data_comparison: this.disableDataComparison,
        reverse_funnel: this.reverseFunnel,
        as_pyramid: this.asPyramid,
        click_through: this.clickThrough,
        click_through_section: this.clickThroughSection,
        hide_table_controls: this.hideTableControls,
        hide_metric_label: this.hideMetricLabel,
        use_doughnut_percentages: this.useDoughnutPercentages,
        options: {}
      }
      if (this.section){
        params.section_id = this.section.value
      }
      params = this.addDefaultSorting(params)
      params = this.addRecordsAmount(params)
      params = this.addLockDates(params)
      params = this.addCompareDates(params)
      params = this.addDefaultPerPage(params)
      if (this.showUniqueLeads) {
        params.options.show_unique_leads = true
      }
      if (this.groupBy.length > 0){
        params.options.group_by = this.groupBy
      }
      if (this.multiYAxis) {
        params.options.multi_y_axis = this.multiYAxis
      }
      if (this.includeTotalsRow) {
        params.options.include_totals_row = this.includeTotalsRow
      }
      if (this.dashboard){
        params.new_dashboard_id = this.dashboard.id
      }
      params.state = JSON.stringify({
        updated_at: Date.now(),
        user: this.currentUser,
        widget: params
      })
      this.widget.update(params, () => this.$parent.loadWidgets())
    },

    create () {
      var params = {
        title: this.title,
        widget_titles: this.widget_titles.map(widget_title => widget_title.label),
        widget_type: this.widgetType,
        data_source_id: this.dataSource.value,
        metric_ids: this.metrics.map(m => m.value),
        table_columns: this.columns.map(c => c.value),
        filters: this.filters,
        shared: this.sharedWidget,
        disable_legend: this.disableLegend,
        y: this.getNextGridHeight(),
        locked: this.locked,
        stacked_barchart: this.stackedBarChart,
        disable_data_comparison: this.disableDataComparison,
        click_through: this.clickThrough,
        as_pyramid: this.asPyramid,
        click_through_section: this.clickThroughSection,
        hide_table_controls: this.hideTableControls,
        hide_metric_label: this.hideMetricLabel,
        use_doughnut_percentages: this.useDoughnutPercentages,
        options: {}
      }
      if (this.$parent.sections.length > 0){
        params.section_id = this.$parent.sections[this.$parent.currentTab].id
      }
      if (this.section){
        params.section_id = this.section.value
      }
      if (this.groupBy.length > 0){
        params.options.group_by = this.groupBy
      }
      if (this.showUniqueLeads){
        params.options.show_unique_leads = true
      }
      if (this.includeTotalsRow) {
        params.options.include_totals_row = this.includeTotalsRow
      }
      params = this.addDefaultSorting(params)
      params = this.addRecordsAmount(params)
      params = this.addLockDates(params)
      params = this.addCompareDates(params)
      params = this.addDefaultPerPage(params)
      params.state = JSON.stringify({
        updated_at: Date.now(),
        user: this.currentUser,
        widget: params
      })
      this.$http.post('/dashboards/'+this.$route.params.id+'/widgets', {widget: params})
        .then(() => this.$parent.loadWidgets(params.section_id))
        .catch((e) => this.notifyError(e))
    },

    loadWidgetTypes () {
      this.$http.get('/widget_types')
        .then(function(response){this.widgetTypesOptions = response.data}.bind(this))
        .catch((e) => this.notifyError(e))
    },

    loadDataSources () {
      this.$http.get('/data_sources')
        .then(response => this.buildDataSourcesOptions(response))
        .catch((e) => this.notifyError(e))
    },

    buildDataSourcesOptions (response) {
      var options = []
      response.data.data.forEach(function(source){
        options.push({
          label: source.attributes.source,
          value: source.id
        })
      })
      this.widgetDataSources = options.sort((a, b) => a.label > b.label ? 1 : -1)
    },

    loadMetrics (dataSourceObject) {
      if (!dataSourceObject) {
        return false
      }
      this.dataSource = dataSourceObject
      this.$http.get('/data_sources/' + dataSourceObject.value + '/metrics')
        .then(response => this.setMetrics(response))
        .catch((e) => this.notifyError(e))
    },

    setMetrics (response) {
      this.widgetMetrics = []
      response.data.data.forEach(function(metric){
        if (metric.attributes.widget_types.includes(this.widgetType)) {
          this.widgetMetrics.push({
            label: metric.attributes.name,
            value: metric.id
          })
        }
      }.bind(this))
    },

    loadTableColumns (metrics) {
      //FIXME: fire twice
      if (Array.isArray(metrics)){
        this.metrics = metrics
      } else {
        this.metrics = [metrics]
      }
      if (this.metrics.length > 0){
        this.loadFilterColumns()
      }
      if ((this.widgetType === 'Table' || this.widgetType === 'Doughnut') && this.metrics.length > 0){
        this.$http.get('/metrics/' + this.metrics[0].value + '/table_columns')
          .then(response => this.setTableColumns(response))
          .catch((e) => this.notifyError(e))
      }
    },

    setTableColumns (response) {
      this.tableColumns = []
      this.tableColumnsForSorting = []
      response.data.data.forEach(function(column){
        this.tableColumns.push({
          label: column.attributes.name,
          value: column.id
        })
        this.tableColumnsForSorting.push(column.attributes.name)
      }.bind(this))
    },

    reset () {
      this.widget_titles = []
      this.sections = []
      this.section = null
      this.groupBy = []
      this.groupByOptions = []
      this.recordsAmount = null
      this.defaultSortColumn = null
      this.defaultSortOrder = null
      this.sharedWidget = false
      this.disableLegend = false
      this.title = null
      this.widgetType = null
      this.dataSource = null
      this.metrics = []
      this.columns = []
      this.filterColumnName = null
      this.filterValue = null
      this.filterInclusion = null
      this.filterComparison = null
      this.filters = []
      this.filterTypes = []
      this.filterType = null
      this.lockDatesCheckbox = false
      this.compareDatesCheckbox = false
      this.lockStartDate = this.$store.getters.startDate
      this.lockEndDate = this.$store.getters.endDate
      this.compareStartDate = this.$store.getters.startDate
      this.compareEndDate = this.$store.getters.endDate
      this.multiYAxis = false
      this.locked = false
      this.ownerId = null
      this.disableDataComparison = false
      this.showUniqueLeads = false
      this.stackedBarChart = false
      this.includeTotalsRow = null
      this.hideTableControls = false
      this.hideMetricLabel = false
      this.useDoughnutPercentages = false
    },

    resetAll () {
      this.reset()
      this.newWidgetMode = false
    },

    addFilter () {
      let filterParams = {
        filter_column_name: this.filterColumnName,
        filter_column_type: this.filterType,
        filter_value: this.filterValue,
        filter_condition: this.filterCondition,
        filter_combine: this.filterCombine,
        filter_inclusion: this.filterInclusion,
        filter_comparison: this.filterComparison
      }
      let filter = this.filterTypes[this.filterColumnName]
      if (typeof(filter) === 'object') {
        filterParams['filter_parent'] = filter.parent.name
        filterParams['filter_parent_type'] = filter.parent.type
      }
      this.filters.push(filterParams)
      this.resetFilterFields()
    },

    resetFilterFields () {
      this.filterColumnName = null
      this.filterValue = null
      this.filterCondition = null
      this.filterCombine = null
      this.filterInclusion = null
      this.filterComparison = null
    },

    removeFilter (filterObject) {
      this.filters.splice(this.filters.indexOf(filterObject), 1)
    },

    addLockDates (params) {
      if (this.lockDatesCheckbox === 'true' || this.lockDatesCheckbox === true) {
        params.lock_start_date = this.lockStartDate.format('YYYY-MM-DD')
        params.lock_end_date = this.lockEndDate.format('YYYY-MM-DD')
      } else {
        delete params['lock_start_date']
        delete params['lock_end_date']
      }
      return params
    },

    addCompareDates (params) {
      if (this.compareDatesCheckbox === 'true' || this.compareDatesCheckbox === true){
        params.compare_start_date = this.compareStartDate.format('YYYY-MM-DD')
        params.compare_end_date = this.compareEndDate.format('YYYY-MM-DD')
      } else {
        delete params['compare_start_date']
        delete params['compare_end_date']
      }
      return params
    },

    notifyError (e) {
      console.log('error', e)
    },

    updateLockDates (datesObject) {
      this.lockDateRange = datesObject
      if (datesObject.value !== 'custom'){
        this.lockStartDate = datesObject.value.startDate
        this.lockEndDate = datesObject.value.endDate
      }
    },

    updateCustomLockDates (dateObj) {
      this.lockStartDate = Moment(dateObj.startDate)
      this.lockEndDate = Moment(dateObj.endDate)
    },

    updateCompareDates (dateObj) {
      this.compareStartDate = Moment(dateObj.startDate)
      this.compareEndDate = Moment(dateObj.endDate)
    },

    cancel () {
      this.selectWidgetMode = false
      this.newWidgetMode = false
      this.modal = false
    },

    loadExistingWidgets () {
      var currentWidgetIds = this.$parent.widgets.map((widget) => parseInt(widget.id, 10))
      var params = {shared: true}
      this.existingWidgets = []
      this.$http.get('/widgets/', { params: params })
        .then(function(data){
          data.data.data.forEach(function(widget){
            widget.label = widget.attributes.title
            widget.value = widget.id
            if (!currentWidgetIds.includes(parseInt(widget.id, 10))){
              this.existingWidgets.push(widget)
            }
          }.bind(this))
        }.bind(this))
        .catch((e) => this.notifyError(e))
    },

    loadFilterColumns () {
      this.$http.get('/data_sources/' + this.dataSource.value + '/metrics/' + this.metrics[0].value + '?filter_columns=true')
        .then(function(response){
          if (this.widgetType != 'Bar') {
            this.filterTypes = response.data
            this.filtersColumnsNames = Object.keys(response.data)
            let group_options = Object.keys(response.data)
            this.groupByOptions = group_options.filter(key => response.data[key] === 'string')
          }
          this.groupByOptions.push('week')
          this.groupByOptions.push('month')
        }.bind(this))
        .catch((e) => this.notifyError(e))
    },

    loadFilterValues (filterColumnName) {
      this.setFilterType(filterColumnName)
      this.filterColumnName = filterColumnName
      if (this.filterType == 'string' || this.filterType == 'array') {
        var currentClient = this.$store.getters.currentClient
        var url = '/data_sources/' + this.dataSource.value + '/metrics/' + this.metrics[0].value + '?filter_values=true&column_name=' + filterColumnName + '&domain=' + currentClient.domain
        if (currentClient.domain === undefined){
          url = '/data_sources/' + this.dataSource.value + '/metrics/' + this.metrics[0].value + '?filter_values=true&column_name=' + filterColumnName + '&client_id=' + currentClient.id
        }
          this.$http.get(url)
          .then(function(response){
            this.filterValues = response.data
          }.bind(this))
          .catch((e) => this.notifyError(e))
      } else {
        this.filterValues = []
      }
    },

    setFilterType (filterColumnName) {
      this.filterType = this.filterTypes[filterColumnName]
      if (typeof(this.filterType) === 'object') {
        this.filterType = this.filterType.type
      }
    },

    getNextGridHeight () {
      var maxY = 0
      var maxH = 0
      this.$parent.widgets.forEach(function(widget){
        if (maxY < parseInt(widget.y, 10)){
          maxY = widget.y
          maxH = widget.h
        }
      }.bind(this))
      return maxY + maxH
    },

    addDefaultSorting (params) {
      if (this.defaultSortColumn) {
        params.options.default_sort_column = this.defaultSortColumn
      }
      if (this.defaultSortOrder) {
        params.options.default_sort_order = this.defaultSortOrder
      }
      return params
    },

    addRecordsAmount (params) {
      if (this.recordsAmount) {
        params.options.records_amount = this.recordsAmount
      }
      return params
    },

    loadSections (dashboard) {
      var dashboardId = this.$route.params.id
      if (dashboard && dashboard.id){
        this.dashboard = dashboard
        dashboardId = dashboard.id
      }
      this.$http.get('/dashboards/'+dashboardId+'/sections')
        .then(function(response){
          this.sections = response.data.map(section => ({label: section.name, value: section.id}))
        }.bind(this))
        .catch((e) => this.notifyError(e))
    },

    loadAllMetrics () {
      this.$http.get('/metrics?all_metrics=true')
        .then((response) => {
          this.allMetrics = response.data.data.map(function(metric) {
             return {
               label: metric.attributes.name,
               value: metric.id
             }
           })
        })
     },

    showName (key, result) {
      if (key === 'metric_ids') {
        var metricNames = []
        for (var i = 0; i < result.length; i++) {
          this.allMetrics.forEach(function(metric){
            if (metric.value == result[i]) {
              metricNames.push(metric.label)
            }
          })
        }
        return metricNames
      } else if (key === 'data_source_id') {
        var theSource = this.widgetDataSources.find ( source => source.value == result)
        return theSource.label
      } else if (key === 'section_id') {
        var theSection = this.sections.find ( section => section.value == result)
        if (theSection) {
          return theSection.label
        }
      } else {
        return result
      }
    }

  },


  computed: {
    ...mapGetters(['currentUser', 'widgetTitles', 'dashboards']),
    clickThroughSectionObject () {
      if (this.sections) {
        let clickSection = this.sections.find ( section => section.value === this.clickThroughSection)
        return clickSection
      } else {
        return {}
      }
    },
    comparisonFilterType () {
      if (this.filterType === 'integer') {
        return true
      } else {
        return false
      }
    },

    groupableByDate () {
      if (this.metrics.length > 0) {
        return this.metrics.length === this.metrics.filter( m => m.groupableByDate ).length
      } else {
        return false
      }
    },

    stateHistory () {
      let state = []
      if (this.widget.widget.state_history) {
        state = this.widget.widget.state_history.map(state => JSON.parse(state)).filter(state => state !== null)
        state.forEach((s) => {
          s.updated_at = Moment(s.updated_at).format('ll h:mm A')
        })
      }
      return state
    }
  },

  watch: {
    dashboards: function () {
      this.formatDashboards()
    },
    widgetType: function (val, oldVal) {
      if (oldVal) {
        this.dataSource = null
        this.metrics = []
        this.columns = []
        this.filterColumnName = null
        this.filterValue = null
        this.filters = []
      }
    },

    dataSource: function (val, oldVal) {
      if (oldVal) {
        this.metrics = []
        this.columns = []
        this.filterColumnName = null
        this.filterValue = null
        this.filters = []
      }
    }
  }

}
</script>

<style scoped>
  #versions-modal .btn {
    background: #3493B2;
    color: #fff;
    border-color: #3493B2;
    margin-top: 10px;
    float: right;
  }
  #versions-modal .btn:hover {
    background: #47889c;
    color: #fff;
    border: 1px solid #47889c;
  }
  #versions-modal h5 {
    font-family: 'Cooper Hewitt Medium';
    text-align: center;
  }
  .modal-btn {
    padding: 8px 20px;
    min-width: 70%;
    font-size: 18px;
  }
  .table > tr > td#filteredValue {
    word-break: break-word;
  }
  input.form-control {
    border: 1px solid rgba(60,60,60,.26);
    min-height: 45px;
  }
  .col-dropdown {
    padding-right: 0;
  }
  .collapsed > .when-opened, :not(.collapsed) > .when-closed {
    display: none;
  }
  #versions-modal .table-container {
    background-color: #EFF7F9;
    padding: 5px;
  }
</style>

<style>
  .filter-dropdowns .dropdown-toggle, .height-45 {
    max-height: 45px;
  }
  .filter-dropdowns .dropdown-multi .dropdown-toggle {
    max-height: unset;
  }
</style>
